import type { SlideProps } from '@mui/material';
import { IconButton, Slide, Snackbar as MuiSnackbar, SvgIcon } from '@mui/material';
import CloseIcon from '@/ui/kit/icons/close.svg';
import { hideToast, useToast } from './showToast';
import useStyles from './toast.styles';
import { ToastAlert } from '../toast-alert';
function TransitionRight(props: SlideProps) {
  return <Slide {...props} direction='left' data-sentry-element="Slide" data-sentry-component="TransitionRight" data-sentry-source-file="Toast.tsx" />;
}
export const Toast = () => {
  const {
    classes
  } = useStyles();
  const {
    open,
    options
  } = useToast();
  const {
    key,
    message,
    title,
    type = "info",
    closeButton = true,
    autoHideDuration = 4000,
    action,
    showSnackBarUnderTopBar = true,
    disableCloseOnClickAway = false
  } = options || {};
  let customAction = null;
  if (closeButton) {
    customAction = <IconButton className={classes.closeBtn} size='large' onClick={hideToast}>
        <SvgIcon component={CloseIcon} />
      </IconButton>;
  }
  if (action) {
    if (typeof action === 'function') {
      customAction = action(hideToast);
    } else {
      customAction = action;
    }
  }
  return <MuiSnackbar key={key} action={customAction} anchorOrigin={{
    vertical: 'top',
    horizontal: 'center'
  }} autoHideDuration={autoHideDuration} ContentProps={closeButton ? {
    sx: {
      flexFlow: 'nowrap',
      alignItems: 'flex-start'
    }
  } : undefined} message={<span style={{
    whiteSpace: 'pre-line'
  }}>
        {message}
      </span>} open={open} sx={{
    top: {
      xs: showSnackBarUnderTopBar ? 80 : 24
    }
  }} TransitionComponent={TransitionRight} onClose={(_, reason) => {
    if (disableCloseOnClickAway && reason === 'clickaway') {
      return;
    }
    hideToast();
  }} data-sentry-element="MuiSnackbar" data-sentry-component="Toast" data-sentry-source-file="Toast.tsx">
      <span><ToastAlert onClose={hideToast} severity={type} variant="filled" sx={{
        width: '100%'
      }} title={title} description={message} titleProps={{
        overflow: "hidden"
      }} data-sentry-element="ToastAlert" data-sentry-source-file="Toast.tsx" />
      </span>
    </MuiSnackbar>;
};